import React from 'react'

const HeroBanner = () => {
  return (
    <div className="home__data">
        <h4 className="home__title home-in">Quality and Performance</h4>
        <h2 className="home__subtitle home-in">Mange Exports International</h2>
        <p className="home__description home-in">Vast experience with the best products on the market</p>
        <a href="#read__more" className="button button--flex home-in">READ MORE</a>
    </div>
  )
}

export default HeroBanner